<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('mindfulMinutes.edit.title')"
        )

        // Create form
        create-form(ref="form" :id="id" :isEditing="true")
</template>

<script>
    import Layout from '../../Layout/Layout';
    import Form from '../Form';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import VueTypes from 'vue-types';

    export default {
        components: {
            Layout,
            CreateForm: Form,
            TitleComponent: Title,
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        props: {
            isEditing: VueTypes.bool.def(false),
            id: VueTypes.string.def('')
        }
    };
</script>
